// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"2462cc2f","883":"2a4b34df"}[chunkId] + ".chunk.js";
};